export { getModuleWorkNavItems } from '@/config/moduleWorkPaths';

/** @deprecated Use getModuleWorkNavItems(module) from moduleWorkPaths */
export { getModuleWorkNavItems as GLOBAL_WORK_NAV_ITEMS_FACTORY } from '@/config/moduleWorkPaths';

/** Module-scoped work nav group id — merged with backend "Workflows" menus in the sidebar. */
export const WORK_NAV_GROUP = {
  id: 'work',
  label: 'Work',
};

/** @deprecated Use WORK_NAV_GROUP */
export const GLOBAL_WORK_NAV_GROUP = WORK_NAV_GROUP;
